<!--
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-09-05 16:06:35
 * @Description:
-->
<template>
  <i v-if="card" class="card-tag" :class="['card-' + card.class]">{{ card.name }}</i>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    // jurisdiction：0 无权益,1:体验权益，2:全科权益
    jurisdiction: Number
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    card() {
      const { jurisdiction } = this
      if (jurisdiction === 0) {
        return {
          name: '无权益',
          class: 'no'
        }
      }
      if (jurisdiction === 1) {
        return {
          name: '体验权益',
          class: 'experience'
        }
      }
      if (jurisdiction === 2) {
        return {
          name: this.userInfo.gddHide ? '高思全科权益' : '小初全科权益',
          class: 'all'
        }
      }
      if (jurisdiction === 3) {
        return {
          name: '高思导引权益',
          class: 'all'
        }
      }
      if (jurisdiction === 4) {
        return {
          name: '高思全科＋高思导引权益',
          class: 'all'
        }
      }
      if (jurisdiction === 5) {
        return {
          name: '数学课',
          class: 'all'
        }
      }
      if (jurisdiction === 6) {
        return {
          name: '数学课+语文课',
          class: 'all'
        }
      }
      if (jurisdiction === 7) {
        return {
          name: '数学课+高思导引',
          class: 'all'
        }
      }
      if (jurisdiction === 8) {
        return {
          name: '数学+语文+导引',
          class: 'all'
        }
      }
      return null
    }
  }
}
</script>
<style lang="less" scoped>
.card-tag {
  display: inline-block;
  font-size: 12px;
  padding: 4px 6px;
  line-height: 1;
  border-radius: 4px;
  word-break: keep-all;
  &.card-no {
    background: #FFF6F6;
    color: #FF5C5C;
  }
  &.card-experience {
    background: #F1F7FF;
    color: #2357FF;
  }
  &.card-all {
    background: #F3FCF8;
    color: #06C270;
  }
}
</style>